import PropTypes from 'prop-types'
import { Avatar } from '@/components/ui/avatar'
import { Tooltip, useIsTruncated } from '@/components/ui/tooltip'
import { theme } from '@/theme/theme'
import { getAssetLink } from '../../../helpers/get-asset-link'

const AMENITY_NAME_LINES = 3

const AmenityItem = ({ amenity, onClick, isSelected }) => {
  const { check, isTruncated, ref } = useIsTruncated(AMENITY_NAME_LINES)

  return (
    <div
      className={`amenity-box${isSelected ? ' amenity-box--selected' : ''}`}
      onClick={() => onClick(amenity)}
    >
      <Avatar
        alt={amenity.name}
        shape="square"
        size="small"
        src={getAssetLink({
          fallback: { file: 'default_amenity.png' },
          file: amenity.image,
          path: 'chitown-building',
        })}
        style={{
          height: theme.space[140],
          width: theme.space[140],
        }}
      />
      <Tooltip
        disabled={!isTruncated}
        fullWidth
        style={{ minWidth: 0 }}
        trigger={
          <div
            ref={ref}
            className={`amenity-box__name${isSelected ? '__selected' : ''}`}
            onMouseEnter={check}
          >
            {amenity.name}
          </div>
        }
      >
        {amenity.name}
      </Tooltip>
    </div>
  )
}

AmenityItem.propTypes = {
  amenity: PropTypes.object,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
}

export default AmenityItem
